import type { FullStackPack, NodeId, UnlockedStrategy } from "~/models/dto";

import type { TypedAction } from "../../../../generic/redux/TypedRedux";

import {
	STACK_PACKS_CONFIRM_MANUAL_ACTIONS_ERROR,
	STACK_PACKS_CONFIRM_MANUAL_ACTIONS_START,
	STACK_PACKS_CONFIRM_MANUAL_ACTIONS_SUCCESS,
	STACK_PACKS_FETCH,
	STACK_PACKS_SET,
	STACK_PACKS_SET_ERROR,
	STACK_PACKS_UPGRADE_ERROR,
	STACK_PACKS_UPGRADE_START,
	STACK_PACKS_UPGRADE_SUCCESS,
} from "./StackPacksActionTypes";

export interface ErrorData {
	error: Error;
}

export interface StackPackData {
	stackPack: FullStackPack;
}

export interface StackPackInstanceData extends StackPackData {
	configurationId: NodeId;
}

export type FetchStackPacks = TypedAction<typeof STACK_PACKS_FETCH>;
export const fetchStackPacks = (): FetchStackPacks => ({ type: STACK_PACKS_FETCH });

export interface SetStackPacksData {
	stackPacks: Array<FullStackPack>;
}
export type SetStackPacks = TypedAction<typeof STACK_PACKS_SET> & SetStackPacksData;
export const setStackPacks = (stackPacks: Array<FullStackPack>): SetStackPacks => ({
	type: STACK_PACKS_SET,
	stackPacks,
});

export type SetStackPacksError = TypedAction<typeof STACK_PACKS_SET_ERROR> & ErrorData;
export const setStackPacksError = (error: Error): SetStackPacksError => ({
	type: STACK_PACKS_SET_ERROR,
	error,
});

export interface UpgradeStackPackData extends StackPackData {
	flag?: UnlockedStrategy;
}

export type UpgradeStackPack = TypedAction<typeof STACK_PACKS_UPGRADE_START> & UpgradeStackPackData;
export const upgradeStackPack = (stackPack: FullStackPack, flag?: UnlockedStrategy): UpgradeStackPack => ({
	type: STACK_PACKS_UPGRADE_START,
	stackPack,
	flag,
});

export interface UpgradeStackPackSuccessData extends StackPackData {}

export type UpgradeStackPackSuccess = TypedAction<typeof STACK_PACKS_UPGRADE_SUCCESS> & UpgradeStackPackSuccessData;
export const upgradeStackPackSuccess = (stackPack: FullStackPack): UpgradeStackPackSuccess => ({
	type: STACK_PACKS_UPGRADE_SUCCESS,
	stackPack,
});

export interface UpgradeErrorStackPackData extends StackPackData {}

export type UpgradeStackPackError = TypedAction<typeof STACK_PACKS_UPGRADE_ERROR> &
	UpgradeErrorStackPackData &
	ErrorData;
export const upgradeStackPackError = (stackPack: FullStackPack, error: Error): UpgradeStackPackError => ({
	type: STACK_PACKS_UPGRADE_ERROR,
	stackPack,
	error,
});

export interface ConfirmManualActionsStackPackData extends StackPackData {
	configId: NodeId;
}

export type ConfirmManualActionsStackPack = TypedAction<typeof STACK_PACKS_CONFIRM_MANUAL_ACTIONS_START> &
	ConfirmManualActionsStackPackData;
export const confirmManualActionsStackPack = (
	stackPack: FullStackPack,
	configId: NodeId,
): ConfirmManualActionsStackPack => ({
	type: STACK_PACKS_CONFIRM_MANUAL_ACTIONS_START,
	stackPack,
	configId,
});

export interface ConfirmManualActionsSuccessStackPackData extends StackPackData {
	configId: NodeId;
}

export type ConfirmManualActionsStackPackSuccess = TypedAction<typeof STACK_PACKS_CONFIRM_MANUAL_ACTIONS_SUCCESS> &
	ConfirmManualActionsSuccessStackPackData;
export const confirmManualActionsStackPackSuccess = (
	stackPack: FullStackPack,
	configId: NodeId,
): ConfirmManualActionsStackPackSuccess => ({
	type: STACK_PACKS_CONFIRM_MANUAL_ACTIONS_SUCCESS,
	stackPack,
	configId,
});
export interface ConfirmManualActionsErrorStackPackData extends StackPackData {
	configId: NodeId;
	error: Error;
}
export type ConfirmManualActionsStackPackError = TypedAction<typeof STACK_PACKS_CONFIRM_MANUAL_ACTIONS_ERROR> &
	ConfirmManualActionsErrorStackPackData;
export const confirmManualActionsStackPackError = (
	stackPack: FullStackPack,
	configId: NodeId,
	error: Error,
): ConfirmManualActionsStackPackError => ({
	type: STACK_PACKS_CONFIRM_MANUAL_ACTIONS_ERROR,
	stackPack,
	configId,
	error,
});
